import { TidySelectStringValueModel } from 'src/models/tidy-select-item.model';

/** Languages the app can be shown in. `value` is the code saved as the `language` metadata and keys language-translations.ts. */
export const DISPLAY_LANGUAGE_OPTIONS: TidySelectStringValueModel[] = [
  { value: 'en', viewValue: 'English' },
  { value: 'pt', viewValue: 'Portuguese' },
  { value: 'es', viewValue: 'Spanish' },
  { value: 'ru', viewValue: 'Russian' },
  { value: 'fr', viewValue: 'French' },
  { value: 'de', viewValue: 'German' },
];

export function getDisplayLanguageName(code: string): string {
  return DISPLAY_LANGUAGE_OPTIONS.find((option) => option.value === code)?.viewValue;
}
